import qs from 'query-string';
import fetch from './request';


// 账号列表(分页)
export function page (params:any) {
  return fetch(`/auth/console/user/page`,{
    method: 'POST',
    body: params
  })
}
// 添加账号
export function create (params:any) {
  return fetch(`/auth/console/user/create`,{
    method: 'POST',
    body: params
  })
}

// 编辑账号
export function modify (params:any) {
  return fetch(`/auth/console/user/modify`,{
    method: 'POST',
    body: params
  })
}
// 账号详情
export function info () {
  return fetch(`/auth/console/user/info`)
}
// 删除账号
export function dele (id:string|number) {
  return fetch(`/auth/console/user/${id}`,{
    method: 'DELETE',
  })
}


